import { render, staticRenderFns } from "./SettingsMenuBoard.vue?vue&type=template&id=401b6ad3&scoped=true"
import script from "./SettingsMenuBoard.vue?vue&type=script&lang=js"
export * from "./SettingsMenuBoard.vue?vue&type=script&lang=js"
import style0 from "./SettingsMenuBoard.vue?vue&type=style&index=0&id=401b6ad3&prod&lang=scss&scoped=true"
import style1 from "./SettingsMenuBoard.vue?vue&type=style&index=1&id=401b6ad3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401b6ad3",
  null
  
)

export default component.exports